import { buildRequestError, cmsRequest } from './httpClient'


export const Api = async (params, pub = true) => {
	let response;
	const config = {
		baseURL: pub ? process.env.REACT_APP_CORE : process.env.REACT_APP_BASE_URL,
		timeout: Number(process.env.REACT_APP_REQUEST_TIMEOUT) || 10000,
	};
	try {
		switch (params.method) {
			case 'get':
		response = await cmsRequest({
				method: 'get',
				url: params.url,
				...config,
				params: params.reqBody
			});
		break;
			case 'post':
				response = await cmsRequest({ method: 'post', url: params.url, data: params.reqBody, ...config });
				break;
			case 'put':
				response = await cmsRequest({ method: 'put', url: params.url, data: params.reqBody, ...config });
				break;
			case 'delete':
				response = await cmsRequest({ method: 'delete', url: params.url, data: params.reqBody, ...config });
				break;
			default:
  				throw new Error('Method not supported');
		}
		return response.data;
	} catch (error) {
		throw buildRequestError(error, 'Request failed')
	}
}
